var _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgBgEllipse3 = function SvgBgEllipse3(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 210,
    height: 88,
    fill: "none",
    viewBox: "0 0 210 88"
  }, props), _g || (_g = /*#__PURE__*/React.createElement("g", {
    filter: "url(#bg-ellipse-3_svg__a)",
    opacity: 0.4
  }, /*#__PURE__*/React.createElement("ellipse", {
    cx: 105,
    cy: 47,
    fill: "url(#bg-ellipse-3_svg__b)",
    rx: 85,
    ry: 29
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "bg-ellipse-3_svg__b",
    x1: 105,
    x2: 105,
    y1: 18,
    y2: 76,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#70EFEF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#46CEB5"
  })), /*#__PURE__*/React.createElement("filter", {
    id: "bg-ellipse-3_svg__a",
    width: 210,
    height: 98,
    x: 0,
    y: -2,
    colorInterpolationFilters: "sRGB",
    filterUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feBlend", {
    in: "SourceGraphic",
    in2: "BackgroundImageFix",
    result: "shape"
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    result: "effect1_foregroundBlur_10535_78326",
    stdDeviation: 10
  })))));
};
export default SvgBgEllipse3;